<template>
    <layout :showuserinfo="false">
        <div class="container-fluid  h-100">

            <div class="page-wrapper-portal">
                <MenuNav />
                <div class="card card-pkn">

                    <Menu :auth="auth" :link="'profil'" />

                    <div class="card-body card-scroll">
                        <div class="row">

                            <div class="col-lg-12">
                                <div class="card">

                                    <div class="card-header">
                                        <h4 class="card-title"><i class="mdi  mdi-account-outline font-16 me-2"></i>Profil
                                            Pelanggan</h4>
                                    </div><!--end card-header-->
                                    <w-alert bg-color="red" color="white" class="my0 mb2 text-light" v-if="salah"
                                        transition="bounce" plain round>
                                        <w-flex class="wrapper">
                                            {{ salah }}
                                            <div class="spacer"></div>
                                            <w-icon md color="red" bg-color="white" @click="pangkal2()">
                                                mdi mdi-close</w-icon>
                                        </w-flex>
                                    </w-alert>

                                    <div class="card-body">
                                        <div class="form-group">
                                            <div class="row">
                                                <w-form class="form-horizontal auth-form" ref="form"
                                                    @validate="submitProfil" @success="success">

                                                    <div class="form-group">
                                                        <label for="kategori" class="form-label  mb-2">Kategori *</label>
                                                        <br>
                                                        <w-radio class="mr2" v-model="form.kategori" name="radio1"
                                                            color="teal-light1" :return-value="1">
                                                            Individu
                                                        </w-radio>

                                                        <w-radio v-model="form.kategori" name="radio1" color="teal-light1"
                                                            :return-value="2">
                                                            Syarikat
                                                        </w-radio>
                                                    </div>
                                                    <div class="form-group mt-2">
                                                        <label for="Name" class="form-label  mb-1 mb-2">Nama *</label>
                                                        <z-input class="mtop" outline
                                                            placeholder="Sila Masukkan Nama Pengguna" type="text"
                                                            name="name" v-model="form.name"
                                                            :validators="[validators.required]" />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="email" class="form-label  mb-1 mb-2">Emel *</label>
                                                        <z-input class="mtop" outline
                                                            placeholder="Sila Masukkan Email Pengguna" type="email"
                                                            name="email" v-model="form.email" disabled />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="no_id" class="form-label  mb-1 mb-2">No. Kad
                                                            Pengenalan/Passport/Syarikat *</label>
                                                        <z-input class="mtop" outline
                                                            placeholder="Sila Masukkan No. Kad Pengenalan/Passport/Syarikat"
                                                            type="text" name="no_id" v-model="form.no_id"
                                                            :validators="[validators.required]" />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="phone_number" class="form-label  mb-1 mb-2">No. Telefon
                                                            *</label>
                                                        <z-input class="mtop" outline
                                                            placeholder="Sila Masukkan No. Telefon Pengguna" type="tel"
                                                            name="phone_number" v-model="form.phone_number"
                                                            :validators="[validators.required]" />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="phone_number" class="form-label  mb-1 mb-2">Alamat Surat
                                                            Menyurat *</label>
                                                        <z-input class="mtop" outline placeholder="Baris 1" type="text"
                                                            name="alamat1" v-model="form.alamat1"
                                                            :validators="[validators.required]" />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="alamat2" class="form-label  mb-1 mb-2">Alamat Surat
                                                            Menyurat</label>
                                                        <z-input class="mtop" outline placeholder="Baris 2" type="text"
                                                            name="alamat2" v-model="form.alamat2" />
                                                    </div><!--end form-group-->
                                                    <div class="form-group mt-2">
                                                        <label for="alamat3" class="form-label  mb-1 mb-2">Alamat Surat
                                                            Menyurat</label>
                                                        <z-input class="mtop" outline placeholder="Baris 3" type="text"
                                                            name="alamat3" v-model="form.alamat3" />
                                                    </div><!--end form-group-->
                                                    <template v-if="$zutil.mobile()">
                                                        <table>
                                                            <tr>
                                                                <td>
                                                                    <z-lookup label="Poskod *" name="poskod"
                                                                        placeholder="Sila Pilih Poskod"
                                                                        :url="app_url + '/poskod'" :sort="false"
                                                                        :cache="false" v-model="form.lkp_poskod_id"
                                                                        :validators="[validators.required]" />
                                                                </td>
                                                                <td class="fw-semibold m0" style="font-size: 11px">
                                                                    Bandar &nbsp;&nbsp;&nbsp;
                                                                    {{ form.bandar }}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="fw-semibold m0" style="font-size: 11px">
                                                                    Negeri &nbsp;&nbsp;&nbsp;
                                                                    {{ form.negeri }}
                                                                </td>
                                                            </tr>

                                                        </table>
                                                    </template>
                                                    <template v-else>
                                                        <w-flex justify-left align-left class="mt5">
                                                            <div class="xs4 mr3 mt-2">
                                                                <z-lookup label="Poskod *" name="poskod"
                                                                    placeholder="Sila Pilih Poskod"
                                                                    :url="app_url + '/poskod'" :sort="false" :cache="false"
                                                                    v-model="form.lkp_poskod_id"
                                                                    :validators="[validators.required]" />
                                                                <!-- <z-lookup
                                                label="Poskod *"
                                                name="poskod"
                                                placeholder="Sila Pilih Poskod"
                                                :url="service_utiliti + 'api/lookup/lkp_poskod'"
                                                :sort="false"
                                                :cache="false"
                                                v-model="form.lkp_poskod_id"
                                                :validators="[validators.required]"
                                            /><br /> -->
                                                            </div>

                                                            <div class="xs4 mr3">
                                                                <td class="fw-semibold m0" style="font-size: 11px">
                                                                    Bandar &nbsp;&nbsp;&nbsp;
                                                                </td>
                                                                <tr>
                                                                    {{
                                                                        form.bandar
                                                                    }}
                                                                </tr>
                                                            </div>
                                                            <div class="xs4">
                                                                <td class="fw-semibold m0" style="font-size: 11px">
                                                                    Negeri &nbsp;&nbsp;&nbsp;
                                                                </td>
                                                                <tr>
                                                                    {{
                                                                        form.negeri
                                                                    }}
                                                                </tr>
                                                            </div>
                                                        </w-flex>
                                                    </template>
                                                    <!-- <div class="form-group mt-2">
                                      <z-lookup label="Negeri" name="negeri" :url='service_utiliti+"lookup/negeri"' :sort="false" :cache="false" v-model="form.negeri"/>                                
                                  </div> -->
                                                    <inertia-link :href='$route("landing.carian")'
                                                        style="text-decoration: none;">
                                                        <button class="btn btn-lupa-katalaluan mt4 mb2 ml2" type="">
                                                            Tutup
                                                        </button>
                                                    </inertia-link>


                                                    <button class="btn btn-lupa-katalaluan mt4 mb2 ml2"
                                                        type="submit">Simpan</button>
                                                </w-form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- <div class="col-lg-3">
                    <div class="card">
                             
                              <div class="card-body">
                                  <div class="text-center">
                                      <div id="ana_device" class="apex-charts hide"></div>
                                      <button class="btn btn-pkn" type="button" @click="logout">Logout</button>
                                      <br>

                                      <button class="btn btn-pkn mt-2" type="button" @click="password">Ubah Kata Laluan</button>
                                  </div>  
                                                                 
                              </div> 
                          </div>
                  </div> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </layout>
</template>

<script type="text/javascript">
import ZResource from '@/Modules/z-resource'

import Menu from '../Menu.vue'
import MenuNav from '../MenuNav.vue'

export default {
    extends: ZResource,
    components: {
        Menu, MenuNav
    },
    setup() {

    },
    props: {
        auth: [Array, Object],
        users: [Array, Object],
        // users: {
        //   default: () => {},
        //   type: Object
        // },
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "api/profil",
            no_rujukan: '',
            senarai: [],
            total_carian: 0.00,
            total_pilih: 0.00,
            cari: 0,
            salah: '',
            // form_profil: {},


            form: {
                name: this.users.name,
                kategori: this.users.kategori,
                email: this.users.email,
                no_id: this.users.no_id,
                phone_number: this.users.phone_number,
                alamat1: this.users.alamat1,
                alamat2: this.users.alamat2,
                alamat3: this.users.alamat3,
                lkp_poskod_id: this.users.poskod,
                bandar: this.users.bandar,
                negeri: this.users.negeri,

            }
        }
    },
    methods: {
        logout() {
            this.$inertia.get('logout')
        },
        password() {
            this.$inertia.get('changePassword')
        },
        submitProfil() {
            if (this.form.name != '' && this.form.kategori != '' && this.form.email != '' && this.form.no_id != '' && this.form.phone_number != '' && this.form.alamat1 != '' && this.form.lkp_poskod_id != '') {
                this.$inertia.post('updateProfil', this.form)
            }
            else {
                this.notify('Terdapat Ralat Dalam Input Anda', 0)
            }
        },

        notify(msg, success = true) {
            if (success)

                this.success = msg
            else
                this.salah = msg
        },

        pangkal2() {
            this.salah = null
        },

        poskodDetail() {
            this.$zcomm
                .get(
                    this.app_url +
                    "/lkp_poskod_detail/" +
                    this.form.lkp_poskod_id
                )
                .then((res) => {
                    this.form.negeri = res.negeri;
                    this.form.lkp_negeri_id = res.lkp_negeri_id;
                    this.form.bandar = res.bandar;
                    this.form.lkp_jenis_alamat_id = 1;
                    // this.form_profil.lkp_jenis_alamat_id = res.lkp_jenis_alamat_id;
                });
        },
    },
    watch: {
        "form.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
    },
    mounted() {
        // override default setting
        this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.cek_pay) {
            // alert('dsaf');
            this.salah = 'Sila legkapkan Emel dan No. Telefon '

            // this.carian();
        }




    }
}
</script>
<style>
.w-input__input-wrap {
    height: 34px;
}

.mtop {
    margin-top: 1px !important;
}

.pkn-carian-landing {
    position: inherit !important;
}
</style>
